<template>
    <div class="default main-con">
        <div class="banner-wrapper" v-if="showDesktop">
            <main-header></main-header>
            <base-menu class="sub-menu con-wrapper" :menu="sub_menu"></base-menu>
        </div>
        <m-top-nav-bar v-if="title && !showDesktop && isAuthenticated" :title="title"></m-top-nav-bar>
        <m-top-bar v-if="title && !showDesktop && !isAuthenticated" :title="title" 
            :lighter="withAccordion" :hide-back-btn="hideBackBtn"></m-top-bar>
        <div :class="`content-con ${withAccordion ? 'with-accordion' : ''} ${!showDesktop ? 'mobile' : ''}`">
            <div class="con-wrapper">
                <div v-if="title && showDesktop" class="page-con-header">
                    <h1>{{ title | translate }}</h1>
                </div>
                <slot name="content"></slot>
                <template v-if="items.length" v-for="item in items">
                    <accordion-item :title="item.question" :content="item.answer"></accordion-item>
                </template>
                <slot name="content-after-accordion"></slot>
            </div>
        </div>
        <m-footer v-if="!showDesktop"></m-footer>
        <main-footer v-if="showDesktop"></main-footer>
    </div>
</template>

<script>
    import MainHeader from '@theme-views/common/MainHeader'
    import MainFooter from '@theme-views/common/MainFooter'
    import BaseMenu from '@views/common/BaseMenu'
    import AccordionItem from '@views/common/AccordionItem'
    import MTopNavBar from '@views/user/partials/mobile/MTopNavBar'
    import MTopBar from '@views/common/mobile/MTopBar'
    import MFooter from '@views/common/mobile/MFooter'    
    import Default from '@views/public/layouts/Default/default'

    export default {
        mixins: [Default],
        components: {
            MainHeader,
            MainFooter,
            MTopNavBar,
            MTopBar,
            MFooter,
            BaseMenu,
            AccordionItem
        }
    }
</script>

<style lang="scss" src="./default.scss"></style>
